export default __webpack_public_path__ + "assets/overview-poster.jpg";